export default "__VITE_ASSET__C7ZSq7j$__"